// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3Nu_9","content":"styles_content__1InSK","checkbox":"styles_checkbox__SAAql","checkboxLabel":"styles_checkboxLabel__2L_oa"};